module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-04.e31fb9a4.svg";